import AddToCartButtonGroup from "@/common/Product/AddToCartButtonGroup";
import React from "react";

export default function ProductCardButton() {
  return <AddToCartButtonGroup />;
}
